import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, Spinner } from "react-bootstrap";
import Box from "@mui/material/Box";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import axios from "axios";
import { Row } from "react-bootstrap/esm";
import { Link, useParams } from "react-router-dom";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import Footer from "../footer/Footer.jsx";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import apiClient from "../../../Api/ApiClient";
import { ToastContainer, toast } from "react-toastify";

export default function GalleryDetail() {
  const { id } = useParams();
  const galleryId = parseInt(id, 10);
  const [galleryData, setGalleryData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedFiles, setSelectedFiles] = useState([]); // Store selected files
  const [title, setTitle] = useState("");

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        //debugger;
        const response = await apiClient.get(
          `/api/Gallery/GetGallery/${galleryId}`,
        );
        setGalleryData(response.data);
        setTitle(response.data.title);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    if (galleryId) {
      fetchGalleryData();
    }
  }, [galleryId]);

  const handleDelete = async (imagePath) => {
    try {
      const updatedImages = galleryData.ImagePaths.filter(
        (image) => image !== imagePath,
      );
      const formData = new FormData();
      formData.append("id", galleryId);
      formData.append("ImagePaths", updatedImages);
      formData.append("titlename", title);

      const response = await apiClient.post(`/api/Gallery/Delete`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setGalleryData({ ...galleryData, ImagePaths: updatedImages });
        setSnackbarMessage("Image deleted successfully.");
        setSnackbarSeverity("success");
        // Refresh the page
        window.location.reload();
      } else {
        setSnackbarMessage("Failed to add images.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      setSnackbarMessage("Failed to delete image.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  // Handle file selection
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);

    // ✅ Allowed extensions
    const allowedExtensions = ["jpg", "jpeg", "png", "mp4"];

    // ✅ Validate each file
    const validFiles = [];
    let hasInvalidFile = false;

    for (const file of files) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        toast.error(`Only JPG, JPEG, and PNG image files are allowed!`);
        hasInvalidFile = true;
      } else {
        validFiles.push(file);
      }
    }

    // ✅ If any invalid file found → clear input and state
    if (hasInvalidFile) {
      event.target.value = ""; // Clear the file input
      setSelectedFiles([]); // Clear the state
      return;
    }

    // ✅ Otherwise, save valid files
    setSelectedFiles(validFiles);
  };

  // const handleFileSelect = (event) => {
  //   const files = Array.from(event.target.files);
  //   const lstImagePaths = files.map((file) => URL.createObjectURL(file)); // Create temporary preview URLs

  //   setSelectedFiles((prevFiles) => [...prevFiles, ...files]); // Store actual files
  //   setGalleryData((prevData) => ({
  //     ...prevData,
  //     lstImagePaths: [...(prevData.lstImagePaths || []), ...lstImagePaths], // Show selected images in the list
  //   }));
  // };

  // Upload selected images
  const handleUploadImages = async () => {
    //debugger;
    if (selectedFiles.length === 0) {
      setSnackbarMessage("Please select at least one image.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    const formData = new FormData();
    formData.append("id", galleryId);
    formData.append("titlename", title);
    formData.append("ImagePaths", galleryData.ImagePaths);
    //setSelectedFiles(...selectedFiles,  updatedImages)
    selectedFiles.forEach((file) => {
      formData.append("lstImagePaths", file); // Append each file
    });

    // setGalleryData({ ...galleryData, ImagePaths: updatedImages });

    try {
      const response = await apiClient.post(
        `/api/Gallery/UpdateGallery`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        setSnackbarMessage("Images added successfully.");
        setSnackbarSeverity("success");
        setSelectedFiles([]); // Clear selected files

        // Refresh the page
        window.location.reload();
      } else {
        setSnackbarMessage("Failed to add images.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error adding images:", error);
      setSnackbarMessage("Failed to add images.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleUpdateTitle = async () => {
    try {
      const formData = new FormData();
      formData.append("id", galleryId);
      formData.append("titlename", title);
      formData.append("ImagePaths", galleryData.ImagePaths);

      const response = await apiClient.post(
        `/api/Gallery/UpdateGalleryTitle`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        setSnackbarMessage("Title updated successfully.");
        setSnackbarSeverity("success");

        setGalleryData({ ...galleryData, title: title });

        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      setSnackbarMessage("Failed to update title.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    {
      field: "image",
      headerName: "Image",
      flex: 1,
      renderCell: (params) => {
        const file = params.value;

        // FIX: ensure correct path
        const filePath = file.startsWith("/Galleryuploads")
          ? file
          : `/Galleryuploads/${file}`;

        const fileUrl = apiClient.defaults.baseURL + filePath;

        const isVideo = file.toLowerCase().endsWith(".mp4");

        if (isVideo) {
          return (
            <video width="120" height="100" controls>
              <source src={fileUrl} type="video/mp4" />
            </video>
          );
        }

        return (
          <img
            src={fileUrl}
            alt={`image-${params.row.id}`}
            style={{ width: "100px", height: "100px" }}
          />
        );
      },
    },
    { field: "imagePath", headerName: "Path", flex: 2 },
    {
      field: "actions",
      headerName: "Actions",
      type: "actions",
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => handleDelete(params.row.imagePath)}
        />,
      ],
    },
  ];

  const rows = galleryData.ImagePaths
    ? galleryData.ImagePaths.filter((img) => img && img.trim() !== "").map(
        (image, index) => ({
          id: index + 1,
          image,
          imagePath: image,
        }),
      )
    : [];

  return (
    <div>
      <Header />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <div className="pagetitle-lft">
            <h1 className="maintitle">Gallery Details</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item">Service</li>
                <li className="breadcrumb-item active">Gallery Data</li>
              </ol>
            </nav>
          </div>
          <div className="pagetitle-rgt">
            <Link to="/dashboard">
              <button type="button" className="btn btn-info">
                Back
              </button>
            </Link>
          </div>
        </div>

        <div>
          <Col md={10} lg={12} xs={12}>
            <Card>
              <Card.Body>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="form-control"
                  style={{ marginBottom: "10px", fontWeight: "bold" }}
                />

                <Button
                  className="update-title-btn"
                  onClick={handleUpdateTitle}
                >
                  Update Title
                </Button>

                {/* File Input */}
                <input
                  type="file"
                  name="file"
                  multiple
                  accept="image/jpeg, image/jpg, image/png, video/mp4"
                  onChange={handleFileSelect}
                  style={{ marginBottom: "10px" }}
                />

                {/* Add Gallery Button */}
                <button
                  type="button"
                  className="btn btn-primary ms-2"
                  onClick={handleUploadImages}
                >
                  Add Gallery
                </button>
              </Card.Body>
            </Card>
          </Col>

          {galleryData.ImagePaths && galleryData.ImagePaths.length > 0 ? (
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
              />
            </Box>
          ) : (
            <p>No images found.</p>
          )}
        </div>
      </main>
      <Footer />

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <ToastContainer />
    </div>
  );
}
